import React, { useState } from "react";
import { Link } from "react-router-dom";
import styled from "styled-components";
import { useMutation } from "@apollo/react-hooks";
import Auth from "../utils/auth";
import { LOGIN_USER } from "../utils/mutations";


const Section = styled.div`
  width: 60%;
  height: auto;
  margin: 15vh auto 4vh auto;
  border: 4px solid burlywood;
  border-radius: 10px;

  display: flex;
  flex-direction: column;
  align-items: center;
`;

const Header = styled.div`
  width: 100%;
  height: auto;
  padding: 1rem;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 2rem;
  margin-bottom: 1rem;
`;

const Details = styled.div`
  width: 100%;
  height: auto;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  font-size: 1.5rem;
  /* border: 1px solid red; */

  input {
    display: block;
    margin: 0.5rem 0;
    margin-bottom: 0.8rem;
    font-size: 1rem;
    padding: 0.2rem 0.6rem;
    border: 2px solid purple;
    border-radius: 4px;
  }

  .submit {
    padding: 0.2rem 0.4rem;
    border: 2px solid black;
    border-radius: 4px;
    font-size: 1.2rem;
    margin: 1rem 0;
    cursor: pointer;
  }
`;

const SignUp = styled.div`
  width: 100%;
  height: 20vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  font-size: 1rem;
  /* border: 2px solid black; */

  a {
    color: blue;
    text-decoration: underline;
    transition: all 0.2s ease;

    &:hover {
      transform: scale(1.1);
    }

    &:active {
      transform: scale(0.9);
      color: purple;
    }
  }
`;

const submitSignIn = (e) => {
  e.preventDefault();
  alert("Submitted");
};

const Login = () => {
  const [formState, setFormState] = useState({ email: "", password: "" });
  const [login, { error }] = useMutation(LOGIN_USER);
  const loggedIn = Auth.loggedIn();

  const handleChange = (event) => {
    const { name, value } = event.target;

    setFormState({
      ...formState,
      [name]: value,
    });
  };

  const handleFormSubmit = async (event) => {
    event.preventDefault();

    try {
      const { data } = await login({
        variables: { ...formState },
      });

      Auth.login(data.login.token);
    } catch (e) {
      console.error(e);
    }


    setFormState({
      email: "",
      password: "",
    });
  };


  return (
    <>
      <Section>
        <Header>Login</Header>
        <Details>
          <form onSubmit={handleFormSubmit}>
            <label>
              E-mail
              <input
                type="email"
                name="email"
                placeholder="e-mail"
                onChange={handleChange}
              />
            </label>
            <label>
              Password
              <input
                type="password"
                name="password"
                placeholder="password"
                onChange={handleChange}
              />
            </label>
            <Link to="/">
              <input type="submit" value="Submit" className="submit" />
            </Link>
          </form>
        </Details>
      </Section>
      <SignUp>
        <h2>Don't have an account??</h2>
        <Link to="/signup">SignUp</Link>
      </SignUp>
    </>
  );
};

export default Login;
